// 外汇分笔
<template>
  <div style="background-color: #fff;height:100%;">
    <div id="chart"></div>
  </div>
</template>
<script>
import {timeFormat} from '../../../controller/util.js';
import { checkExchange } from '../../../../packages/controller/util';
export default {
  name: 'tickChart',
  props: {
    prod_code:{
      type: String,
      required: true
    },
    throttle:{
      type: Number,
      default: 3000
    }
  },
  data() {
    return {
      ext_code: undefined, // 成交价代码
      quote_code: undefined, // 报价代码
      extList:[], // 成交价数据
      quoteBuyList:[], // 报买数据
      quoteSellList:[], // 报卖数据
      chartXAxis:[], // 图中横坐标
      timer: undefined, // 定时器
      currentApiData: [], //当前查询到的数据
      currentApiXAxis: [], //当前查询到的横坐标
      appendXAxis: new Set(), // 增量查询到的时间轴数组
      myChart: undefined // 绘图实例
    }
  },
  created() {
    if (checkExchange(this.prod_code)) {
      // 外汇板块
      this.dealWHBusiness()
    }
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
  mounted() {
  },
  destroyed(){
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
  computed:{
    // 滑块默认条数250条
    dataZoom_start () {
      if (this.chartXAxis.length<=250) {
        return this.specialTimeFormat(this.chartXAxis[0] +'')
      }else {
        return this.specialTimeFormat(this.chartXAxis[this.chartXAxis.length-250] + '')
      }
    }
  },
  methods: {
    // 处理外汇数据
    async dealWHBusiness() {
      let _this = this
      const promiseQueue = []
      await this.getWHProds()
      const monthBefore = timeFormat(new Date(new Date().valueOf()-31*24*60*60*1000), 'yyyyMMddhhmm')
      _this.ext_code && promiseQueue.push(_this.getTick(_this.ext_code,monthBefore))
      _this.quote_code && promiseQueue.push(_this.getTick(_this.quote_code,monthBefore,2)) // 报买
      _this.quote_code && promiseQueue.push(_this.getTick(_this.quote_code,monthBefore,3)) // 报卖
      const [a,b,c] = await Promise.all(promiseQueue)
      a && (_this.extList = a)
      b && (_this.quoteBuyList = b)
      c && (_this.quoteSellList = c)
      _this.chartXAxis = _this.currentApiXAxis
      _this.drawChart()
      if (this.throttle>0 && (a && a.length>0 || (b && b.length>0) || (c && c.length>0))) {
        this.timer = setInterval(this.drawTimer, 10000);
      }
    },
    // 定时轮询
    async drawTimer() {
      this.currentApiXAxis = []
      this.currentApiData = []
      const promiseArr = []
      this.ext_code && promiseArr.push(this.getOffsetTick(this.ext_code,this.getTodayLength(this.extList),''))
      this.quote_code && promiseArr.push(this.getOffsetTick(this.quote_code,this.getTodayLength(this.quoteBuyList),2)) // 报买
      this.quote_code && promiseArr.push(this.getOffsetTick(this.quote_code,this.getTodayLength(this.quoteSellList),3)) // 报卖
      const [a,b,c] = await Promise.all(promiseArr)
      // 数据拼接
      this.extList = this.extList.concat(a)
      this.quoteBuyList = this.quoteBuyList.concat(b)
      this.quoteSellList = this.quoteSellList.concat(c)
      this.myChart.setOption({
        xAxis: {
          data:this.chartXAxis.map(str=>{
            return this.specialTimeFormat(str+'')
          })
        },
        series: [
          {
            data:this.extList.map(item=>{
              return [this.specialTimeFormat(item[0]+''),item[1]]
            }),
          },
          {
            data:this.quoteBuyList.map(item=>{
              return [this.specialTimeFormat(item[0]+''),item[1]]
            }),
          },
          {
            data:this.quoteSellList.map(item=>{
              return [this.specialTimeFormat(item[0]+''),item[1]]
            }),
          }
        ]
      })
    },
    // 按偏移获取tick，用于轮询
    async getOffsetTick(code, start_pos, business_type){
      let _this = this
      const fields = 'business_time,hq_px'
      const dataCount = 10000
      const search_direction = 2
      const promise = new Promise((resolve,reject) => {
        _this.OpenAPI.tick({code,fields, dataCount, start_pos, business_type, search_direction}).then(res => {
          const tickList = res.data.tick[code]
          if(!tickList){
            return
          }
          const lastXAxis = new Set(_this.chartXAxis)
          tickList.forEach((item,i)=>{
            lastXAxis.add(item[0])
          })
          _this.chartXAxis = Array.from(lastXAxis).sort()
          resolve(tickList)
        })
      })
      return promise
    },
    // 获取外汇板块对应的成分股们
    getWHProds() {
      let _this = this
      const promise = new Promise(function(resolve,reject){
        _this.OpenAPI.block_elements(_this.prod_code).then(res=>{
          const prodList = res.data.block_elements[_this.prod_code]
          const fields = res.data.block_elements.fields
          const business_type_index = fields.indexOf('business_type')
          for(let i in prodList) {
            let business_type = prodList[i][fields.indexOf('business_type')]
            let code = prodList[i][fields.indexOf('prod_code')]+'.'+prodList[i][fields.indexOf('hq_type_code')].split('.')[0]
            if(business_type === 1) {
              // 成交价
              _this.ext_code = code
            }else if(business_type === 2) {
              // 报价
              _this.quote_code = code
            }
          }
          resolve()
        })
      })
      return promise
    },
    // 外汇分笔
    getTick(code,start_date_time,business_type){
      let _this = this
      const promise = new Promise(function(resolve,reject){
        _this.OpenAPI.tickRange({code,start_date_time,business_type}).then(res => {
          const tickList = res.data.tick[code]
          if (!tickList || tickList.length==0) {
            resolve([])
            return
          }
          const today = (tickList[tickList.length-1][0]+'').slice(4,8)
          let date = new Set()
          for(let i in tickList) {
            const iValue = tickList[i][1]
            const time = tickList[i][0]
            date.add(time)
            if(!iValue){
              tickList[i][1] = null
            }
          }
          // 横坐标保留最长的日期
          _this.currentApiXAxis ? (_this.currentApiXAxis = Array.from(new Set([...date, ..._this.currentApiXAxis]))) : (_this.currentApiXAxis = Array.from(date))
          _this.currentApiXAxis.sort()
          _this.currentApiData.push(tickList)
          resolve(tickList)
        })
      })
      return promise
    },
    // 绘制分笔图
    drawChart() {
      let _this = this
      let option = {
        tooltip: {
          trigger: 'axis',
          // hideDelay:3000,
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#969696',
              borderRadius: 2
            },
            lineStyle: {
              type: 'dotted',
              color: '#bcbcbc',
              width: 2
            },
            snap: true
          },
          backgroundColor: '#fff',
          borderWidth: 1,
          borderColor: '#4EABF9',
          padding: 5,
          textStyle: {
            color: '#666666'
          },
          // formatter: function(params){
          //   return _this.getToolTipContent(params)
          // }
        },
        legend: {
          top: '0',
          data:['成交价','最优买价','最优卖价']
        },
        grid: {
          top: '5%',
          left: '1%',
          right: '3%',
          bottom: '10%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data:_this.chartXAxis.map(str=>{
            return _this.specialTimeFormat(str+'')
          }),
          // triggerEvent: true,
          axisLine: {
            lineStyle: {
              color: '#DCDCDC',
              width: 2
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: '#333'
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dotted',
              color: '#DCDCDC'
            }
          }
        },
        dataZoom: [{
          type: 'slider',
          // start: 80,
          // end: 100,
          startValue: _this.dataZoom_start
          // labelFormatter: function (value) {
          //   return '';
          // }
        }],
        yAxis: {
          type: 'value',
          scale: true, // 不要求0刻度
          axisLine: {
            lineStyle: {
              color: '#DCDCDC',
              width: 2
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: '#333'
          },
          splitLine: {
            lineStyle: {
              type: 'dotted',
              color: '#DCDCDC'
            }
          },
          axisPointer: {
            lineStyle: {
              type: 'dotted',
              color: '#bcbcbc',
              width: 2
            }
          }
        },
        series: [
          {
            name:'成交价',
            type:'line',
            data:_this.extList.map(item=>{
              return [_this.specialTimeFormat(item[0]+''),item[1]]
            }),
            color:'#3896FF',
            connectNulls: true
          },
          {
            name:'最优买价',
            type:'line',
            data:_this.quoteBuyList.map(item=>{
              return [_this.specialTimeFormat(item[0]+''),item[1]]
            }),
            color:'#F95EB8',
            connectNulls: true
          },
          {
            name:'最优卖价',
            type:'line',
            data:_this.quoteSellList.map(item=>{
              return [_this.specialTimeFormat(item[0]+''),item[1]]
            }),
            color:'#FF8A00',
            connectNulls: true
          }
        ]
      };
      _this.myChart = this.echarts.init(document.getElementById('chart'))
      _this.myChart.setOption(option)

      _this.myChart.on('mouseover', ()=>{
        _this.myChart.setOption({
          tooltip:{
            alwaysShowContent: true
          }
        })
      })
      _this.myChart.on('mouseout', ()=>{
        _this.myChart.setOption({
          tooltip:{
            alwaysShowContent: false
          }
        })
      })
    },
    // 特定的时间格式处理
    specialTimeFormat(str) {
      return str.slice(0,4)+'-'+str.slice(4,6)+'-'+str.slice(6,8) + '\n' + str.slice(8,10)+':'+str.slice(10,12)+':'+str.slice(12,14)
    },
    // 获取arr中最新一天的数据长度
    getTodayLength(arr){
      if(!arr){
        return 0
      }
      const newDay = (arr[arr.length-1]+'').slice(4,8)
      let count = 0
      arr.forEach((item,index)=>{
        if ((item[0]+'').slice(4,8) === newDay) {
          count++
        }
      })
      return count
    },
    getToolTipContent(params) {
      let index = params[0].dataIndex;
      let axisArr = params[0].axisValue.split('\n');
      let html = `${axisArr[0]} ${axisArr[1]}<br>`;
      params.forEach(item=>{
        html += `<span style="height:10px;width:10px;border-radius:50%;background-color:${item.color};display:inline-block;"></span> ${item.seriesName}：${item.value[1]}<br>`
      })
      return html
    }
  }
}
</script>
<style scoped>
#chart {
  /* 与k线一起使用时占据不显示的指标空间 */
  height: 135%;
}
</style>
